import { Box, Button, Flex, FlexProps, Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { Icon } from "../../components/Icon/Icon";

const CONFETTI = [
  { left: "10px", top: "14px", w: "10px", h: "3px", rotate: "-20deg", color: "gf.green.500" },
  { left: "148px", top: "8px", w: "12px", h: "3px", rotate: "25deg", color: "gf.green.500" },
  { left: "6px", top: "86px", w: "8px", h: "3px", rotate: "40deg", color: "gf.green.200" },
  { left: "154px", top: "92px", w: "10px", h: "3px", rotate: "-30deg", color: "gf.green.200" },
  { left: "30px", top: "4px", w: "4px", h: "4px", rotate: "0deg", color: "gf.green.500", dot: true },
  { left: "140px", top: "42px", w: "3px", h: "3px", rotate: "0deg", color: "gf.green.500", dot: true },
  { left: "22px", top: "52px", w: "3px", h: "3px", rotate: "0deg", color: "gf.green.200", dot: true },
  { left: "160px", top: "70px", w: "4px", h: "4px", rotate: "0deg", color: "gf.green.500", dot: true },
];

interface ConfettiFlagEmptyStateProps extends FlexProps {
  headline: ReactNode;
  body: ReactNode;
  cta?: { label: string; onClick: () => void };
}

export const ConfettiFlagEmptyState = ({
  headline,
  body,
  cta,
  ...flexProps
}: ConfettiFlagEmptyStateProps) => {
  return (
    <Flex
      flex="1"
      direction="column"
      align="center"
      justify="center"
      textAlign="center"
      px="8"
      pt="6"
      pb="12"
      {...flexProps}
    >
      <Box position="relative" w="180px" h="110px" mb="7">
        {CONFETTI.map((c, i) => (
          <Box
            key={i}
            position="absolute"
            left={c.left}
            top={c.top}
            w={c.w}
            h={c.h}
            bg={c.color}
            borderRadius={c.dot ? "full" : "2px"}
            transform={`rotate(${c.rotate})`}
          />
        ))}
        <Box
          position="absolute"
          left="50%"
          top="50%"
          transform="translate(-50%, -50%) rotate(-8deg)"
        >
          <Icon name="logo" boxSize="84px" color="fg.brand" />
        </Box>
      </Box>

      <Text
        as="h2"
        fontSize="xl"
        fontWeight="medium"
        color="fg.default"
        lineHeight="1.255"
        maxW="320px"
        mb="3.5"
      >
        {headline}
      </Text>
      <Text
        fontSize="sm"
        color="fg.muted"
        lineHeight="1.45"
        maxW="300px"
        mb={cta ? "7" : "0"}
      >
        {body}
      </Text>

      {cta && (
        <Button
          onClick={cta.onClick}
          h="48px"
          px="7"
          borderRadius="full"
          bg="bg.brand"
          color="fg.onBrand"
          fontWeight="semibold"
          fontSize="sm"
          boxShadow="0 0 12.1px 2px rgba(0,0,0,0.05)"
        >
          {cta.label}
        </Button>
      )}
    </Flex>
  );
};
